export default "__VITE_ASSET__B6obUG11__"